import { memo } from 'react'
import { PropsDataContratos } from '../Pagos/ModalTablePagos'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { format } from 'date-fns'

/* eslint-disable react/prop-types */

interface Props extends PropsDataContratos {
  handleDelete?: () => void
}

const ModalCardsLinks: React.FC<Props> = ({ show, data, handleClose, title, handleDelete }) => {
  return (
    <Dialog
      open={show}
      onClose={handleClose}
      maxWidth={'xs'}
      PaperProps={{
        sx: {
          overflowX: 'hidden',
          marginLeft: '-1rem',
          width: '90%'
        }
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <DialogTitle>{title}</DialogTitle>
        <Button
          variant="contained"
          color="error"
          onClick={handleDelete}
          size={'small'}
          style={{ margin: '1rem 1rem 0rem auto', height: '50%' }}
        >
          Eliminar links del local
        </Button>
      </Box>

      <DialogContent>
        <Box>
          {data.items?.map((item, index) => {
            const fechaAlta = new Date(item.fechaAlta)
            const fechaVencimiento = new Date(item.fechaVencimiento)
            return (
              <Box sx={{ p: 1, m: '1rem 0', boxShadow: 1, width: 'auto' }} key={index}>
                <Box>
                  <Typography variant="body1">
                    <strong>ID: {item.idContratoPagoLink}</strong>
                  </Typography>
                  <Typography variant="body1">Fecha Alta: {format(fechaAlta, 'dd/MM/yyyy HH:mm:ss')}</Typography>
                  <Typography variant="body1">
                    Fecha Vencimiento: {format(fechaVencimiento, 'dd/MM/yyyy HH:mm:ss')}
                  </Typography>
                  <Typography variant="body2">Medio de Pago: {item.platform}</Typography>
                  <Typography variant="body2">Fuente: {item.source}</Typography>
                  <Typography variant="body2">Tiene Pagos: {item.tienePagos ? 'SI' : 'NO'}</Typography>
                  <Typography variant="body2">
                    <a href={item.link} target="_blank" rel="noopener noreferrer">
                      {item.link}
                    </a>
                  </Typography>
                </Box>
              </Box>
            )
          })}
        </Box>
      </DialogContent>
      <DialogActions>
        <button onClick={handleClose} className="btn btn-secondary">
          Cerrar
        </button>
      </DialogActions>
    </Dialog>
  )
}

export default memo(ModalCardsLinks)
